import React from "react";
import { TextField, Button, Grid } from "@mui/material";
import { useForm } from "react-hook-form";
import { EventFormData } from "../Admin/CreateEvents";

interface EventFormProps {
  onSubmit: (data: EventFormData) => void;
  defaultValues: EventFormData;
}

const EventForm: React.FC<EventFormProps> = ({ onSubmit, defaultValues }) => {
  const { register, handleSubmit, reset } = useForm<EventFormData>({
    defaultValues,
  });

  React.useEffect(() => {
    reset(defaultValues);
  }, [defaultValues, reset]);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField label="Title" fullWidth {...register("title")} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField label="Booth" fullWidth {...register("booth")} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField label="Location" fullWidth {...register("location")} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField label="Date" type="date" fullWidth InputLabelProps={{ shrink: true }} {...register("date")} />
        </Grid>
        
        <Grid item xs={12} sm={6}>
          <TextField label="Tag" fullWidth {...register("tag")} />
        </Grid>
        <Grid item xs={12}>
          <Button variant="contained" color="primary" type="submit">
            Add Event
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default EventForm;
